import DOMPurify from 'dompurify';
import { marked } from 'marked';

export const EMPTY_RELEASE_NOTES = 'No release notes provided.';

export function renderReleaseNotes(container: HTMLElement, notes: string | null | undefined): void {
  container.replaceChildren();

  const markdown = notes?.trim() ?? '';
  if (!markdown) {
    appendPlainText(container, EMPTY_RELEASE_NOTES, 'release-notes__empty');
    return;
  }

  try {
    const html = marked.parse(markdown, {
      async: false,
      gfm: true,
    });
    if (typeof html !== 'string') {
      throw new Error('Markdown parser returned asynchronously.');
    }
    container.innerHTML = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
  } catch (error) {
    appendPlainText(container, markdown);
  }
}

function appendPlainText(container: HTMLElement, text: string, className?: string): void {
  const paragraph = document.createElement('p');
  if (className) {
    paragraph.className = className;
  }
  paragraph.textContent = text;
  container.append(paragraph);
}
